/* The mobile shortcut submits the same Shopify product form as the main button. */
(() => {
  'use strict';
  const root = document.querySelector('.leni-product-page');
  const primary = root?.querySelector('[data-ls-add]');
  const dock = root?.querySelector('[data-leni-mobile-buy]');
  const shortcut = dock?.querySelector('button');
  if (!primary || !dock || !shortcut) return;
  const media = matchMedia('(max-width:699px)');
  let visible = false;
  const sync = () => {
    shortcut.textContent = primary.textContent.trim();
    shortcut.disabled = primary.disabled;
    dock.hidden = !media.matches || visible;
  };
  shortcut.addEventListener('click', () => {
    if (!primary.disabled) primary.click();
  });
  media.addEventListener('change', sync);
  new IntersectionObserver(entries => {
    visible = entries[0].intersectionRatio >= .99;
    sync();
  }, {threshold: [0, 1], rootMargin: '0px 0px -50px 0px'}).observe(primary);
  sync();
})();
